export default function RgpdCheckbox({ checked, onChange, testid }) {
  return (
    <label className="flex items-start gap-3 cursor-pointer select-none">
      <input
        type="checkbox"
        data-testid={testid}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-1 w-4 h-4 shrink-0 accent-[#FF1E27]"
        required
      />
      <span className="text-xs text-zinc-400 leading-relaxed">
        J'accepte que mes données personnelles soient utilisées par Groupe Huvig uniquement pour
        traiter ma demande, conformément au RGPD. Elles ne sont ni cédées ni revendues.{" "}
        <span className="text-[#FF1E27]">*</span>
      </span>
    </label>
  );
}
